import React from 'react';
import ReportSectionPage from '../../../common/components/reports/ReportSectionPage';

const VoucherReport = () => {
  return <ReportSectionPage scope="super-admin" section="vouchers" title="Voucher Report" />;
};

export default VoucherReport;
